const common = {
  'site.name': '黑料吃瓜',
  'site.fullName': '黑料吃瓜·最新娱乐爆料聚合平台',
  'site.tagline': '吃瓜群众必备的娱乐爆料阵地',
  'nav.home': '首页',
  'nav.categories': '分类',
  'nav.about': '关于我们',
  'nav.search': '搜索爆料...',
  'category.all': '全部',
  'category.mingxing-bagua': '明星八卦',
  'category.wanghong-fanche': '网红翻车',
  'category.remen-guaqing': '热门瓜情',
  'category.zongyi-baoliao': '综艺爆料',
  'category.yingshiquan': '影视圈',
  'article.readMore': '阅读全文',
  'article.publishedAt': '发布时间',
  'article.views': '阅读',
  'article.comments': '评论',
  'article.author': '作者',
  'article.tags': '标签',
  'article.relatedArticles': '相关文章',
  'article.backToList': '返回列表',
  'home.hero.title': '最新娱乐爆料，一站吃瓜到底',
  'home.hero.subtitle': '明星八卦、网红翻车、热门瓜情实时更新，吃瓜群众每日必刷',
  'home.hero.cta': '开始吃瓜',
  'home.featured': '精选爆料',
  'home.latest': '最新瓜情',
  'home.hotTopics': '热门话题',
  'home.newsletter.title': '订阅每日瓜情',
  'home.newsletter.subtitle': '不错过任何一个大瓜！订阅后每天为您推送最新娱乐爆料',
  'home.newsletter.placeholder': '输入您的邮箱地址',
  'home.newsletter.button': '免费订阅',
  'home.newsletter.success': '订阅成功！请查收确认邮件',
  'home.newsletter.error': '订阅失败，请稍后重试',
  'home.viewAll': '查看全部',
  'about.title': '关于我们',
  'about.brandIntro': '品牌介绍',
  'about.reputation': '口碑声誉',
  'about.contact': '联系我们',
  'about.faq': '常见问题',
  'footer.copyright': '© 2026 黑料吃瓜 版权所有',
  'footer.disclaimer': '本站内容仅供娱乐参考，不构成任何建议。如有侵权请联系删除。',
  'footer.links.about': '关于我们',
  'footer.links.privacy': '隐私政策',
  'footer.links.terms': '用户协议',
  'footer.links.contact': '联系我们',
  'breadcrumb.home': '首页',
  'scrollToTop': '回到顶部',
  'loading': '加载中...',
  'noArticles': '暂无相关文章',
  'search.placeholder': '输入关键词搜索爆料...',
};

export default common;